<template>
  <div class="landing-page" id="landing-page">
    <side-bar-big class-name="first"></side-bar-big>
    <div class="message">
      <h1>
        I'm a <br />
        <span class="typed-text" :style="typeArray[typeArrayIndex].style">{{
          typeValue
        }}</span>
      </h1>
    </div>
  </div>
</template>

<script>
import SideBarBig from "../components/SideBarBig.vue";
export default {
  components: {
    SideBarBig,
  },
  data: () => {
    return {
      typeValue: "",
      typeStatus: false,
      typeArray: [
        {
          text: "self-learner",
          style: {
            "font-family": "GoudyBookletter1911",
            "letter-spacing": "0.05em",
          },
        },
        {
          text: "teacher",
          // style: {'font-family': 'Caveat', 'font-size': '2em'},
          style: {
            "font-family": "Calligraffitti",
            transform: "scaleX(1.2)",
            "letter-spacing": "0.125em",
          },
        },
        {
          text: "developer",
          style: {
            "font-family": "IBM Plex Mono",
            "letter-spacing": "-0.05em",
          },
        },
      ],
      typingSpeed: 200,
      erasingSpeed: 100,
      newTextDelay: 2000,
      typeArrayIndex: 0,
      charIndex: 0,
    };
  },
  methods: {
    typeText() {
      if (this.charIndex < this.typeArray[this.typeArrayIndex].text.length) {
        if (!this.typeStatus) {
          this.typeStatus = true;
        }
        this.typeValue += this.typeArray[this.typeArrayIndex].text.charAt(
          this.charIndex
        );
        this.charIndex += 1;
        setTimeout(this.typeText, this.typingSpeed);
      } else {
        this.typeStatus = false;
        setTimeout(this.eraseText, this.newTextDelay);
      }
    },
    eraseText() {
      if (this.charIndex > 0) {
        if (!this.typeStatus) {
          this.typeStatus = true;
        }
        this.typeValue = this.typeArray[this.typeArrayIndex].text.substring(
          0,
          this.charIndex - 1
        );
        this.charIndex -= 1;
        setTimeout(this.eraseText, this.erasingSpeed);
      } else {
        this.typeStatus = false;
        this.typeArrayIndex += 1;
        if (this.typeArrayIndex >= this.typeArray.length) {
          this.typeArrayIndex = 0;
        }
        setTimeout(this.typeText, this.typingSpeed + 1000);
      }
    },
  },
  created() {
    setTimeout(this.typeText, this.newTextDelay + 200);
  },
};
</script>

<style scoped lang="scss">
@import "../styles/views/LandingPage.scss";
</style>
